module.exports = __webpack_public_path__ + "static/img/phone_afsc_icon3.a653fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone_afsc_icon3.png
// module id = jyiL
// module chunks = 1